<template>
  <footer class="checkout-footer">
    <div class="checkout-footer__top">
      <div class="checkout-footer__container container">
        <div class="checkout-footer__heading">
          Wij helpen je graag
        </div>

        <a
          href="tel:+3251269888"
          rel="noopener noreferrer"
          class="checkout-footer__button button button--ghost"
        >
          <IconPhone class="icon" />
          <span>Bel +32(0) 51 26 98 88</span>
        </a>

        <p class="checkout-footer__opening-hours">
          Maandag tot zaterdag tussen 09.00 - 18.30 uur.
        </p>

        <AppLink class="checkout-footer__logo logo">
          <svg
            viewBox="0 0 101.04 150.88"
            class="logo__image"
          >
            <path
              fill="#010200"
              d="M95.57 43.46h21.59c8.25.09 20.72.29 29.36 8 7 6.34 9.69 15.84 9.69 25.33a45.46 45.46 0 01-1.73 13c-6.24 20.92-25.14 21.3-32.24 21.4H95.57zm17.07 14.3v39.81h5.19c9-.19 21.49-.67 21.49-20.15 0-4.69-.48-9.4-3.55-13.62-4.61-6.14-11.13-6-16.31-6zM68 104.18h16.85v58.59h26.48v14.3H68z"
              transform="translate(-67.96 -43.46)"
            />
            <path
              fill="#010200"
              d="M135.73 139.55l-3.32 5.18a31.66 31.66 0 00-2.78 5.08l-14.58-23.21H95.57L121 162.77v31.57h16.7v-32.05l10.3-14.35a22 22 0 01-12.27-8.39z"
              transform="translate(-67.96 -43.46)"
            />
            <path
              fill="#010200"
              d="M138.21 126.59a15.4 15.4 0 1015.4-15.39 15.39 15.39 0 00-15.4 15.39z"
              transform="translate(-67.96 -43.46)"
            />
          </svg>
        </AppLink>

        <!-- <AppContact class="checkout-footer__contact" /> -->

        <AppPaymentIcons class="checkout-footer__payment-icons" />
      </div>
    </div>
    <div class="checkout-footer__bottom">
      <div class="checkout-footer__container container">
        <div class="checkout-footer__legal">
          <ul
            v-if="response?.data?.footerBottom?.[0]"
            class="checkout-footer__legal-list"
          >
            <li
              v-for="(group, index) in response?.data.footerBottom[0].Links"
              :key="index"
            >
              <component
                :is="getElement(group.Link)"
                v-if="group.Name"
                :to="group.Link"
              >
                {{ group.Name }}
              </component>
            </li>
          </ul>

          <div class="checkout-footer__copyright">
            {{ $t('Copyright') }}&copy;{{ year }} {{ $t('nuxtSiteConfig.name') }}
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script lang="ts" setup>
// import layoutQuery from '~layers/app/graphql/layout.gql'
import { AppLink } from '#components'

const { public: config } = useRuntimeConfig()
// const { data } = await useAsyncQuery(layoutQuery, { locale: config.strapiLocale })

const { data: response } = await useAsyncGraphqlQuery('layout', {
  locale: config.strapiLocale,
}, useGraphqlDefaultClient())

const getElement = (to: any) => {
  return to ? AppLink : 'span'
}

const year = new Date().getFullYear()
</script>

<!-- <style src="~layers/app/components/Checkout/Footer.css" /> -->
<style>
@import url("~layers/app/components/Checkout/Footer.css");
</style>
